/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */

import 'https://code.jquery.com/jquery-3.7.1.min.js';

function delay(callback, ms) {
    var timer = 0;
    return function () {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, ms || 0);
    };
}

const mainSlider = $('.block-project-adv');
const navCards = mainSlider.find('.adv-block-navs-card');
const imagesBlock = mainSlider.find('.block-project-adv-content');
let firstBlockImg = true;

imagesBlock.find('.adv-block-content-img').each(function () {
    // $(this).hide();
    // console.log('123');
    if (!firstBlockImg) {
        $(this).css('display', 'none');
    }
    firstBlockImg = false;
});

function setActive(el) {
    navCards.removeClass('active');
    el.addClass('active');
}

function showImg(dataColor) {
    const selector = "[data-card-color='" + dataColor + "']";
    imagesBlock.find('.adv-block-content-img').each(function () {
        $(this).hide();
        // $(this).attr('display', 'none');
    });
    const findSelector = imagesBlock.find(selector);
    // findSelector.attr('display', 'flex');
    findSelector.toggle('drop');
}

let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

//set active
function twoSliderActive(e) {
    return function (e) {
        e.stopPropagation();
        if ($(this).hasClass('active')) {
            return
        } else {
            setActive($(this));

            const dataColor = $(this).data('card-color');
            showImg(dataColor);
        }
    }
}

if (isMobile) {
    navCards.click(
        delay(twoSliderActive(this), 300)
    )
} else {
    navCards.hover(
        delay(twoSliderActive(this), 300)
    )
}
$(navCards[0]).mouseenter().mouseleave();
/* eslint-enable no-console */
